import { render, staticRenderFns } from "./TenderRequests.vue?vue&type=template&id=abbe5e64&"
import script from "./TenderRequests.vue?vue&type=script&lang=js&"
export * from "./TenderRequests.vue?vue&type=script&lang=js&"
import style0 from "./TenderRequests.vue?vue&type=style&index=0&id=abbe5e64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports